<template>
  <div v-if="withSwap" data-qa="swap-offer">
    <RevDivider class="my-16" />
    <div class="flex gap-24">
      <div
        class="border-static-default-low rounded-sm flex h-40 w-40 items-center justify-center border"
      >
        <IconSwap />
      </div>
      <div class="body-2 grow">
        <div class="flex justify-between gap-24">
          <h2 class="body-2-bold">{{ i18n(translations.swap) }}</h2>
          <div>
            {{ swapOffer?.price ? `(-${i18n.price(swapOffer?.price)})` : '' }}
          </div>
        </div>
        <div class="mt-8">
          <div>{{ swapOffer?.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { BuybackOffer } from '@backmarket/http-api'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevDivider } from '@ds/components/Divider'
import { IconSwap } from '@ds/icons/IconSwap'

import translations from './TradeIn.translations'

defineProps<{ withSwap: boolean; swapOffer?: BuybackOffer | null }>()

const i18n = useI18n()
</script>
